import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// --- Configuration AXIOS Globale ---
// URL définie via .env.development / .env.production (VUE_APP_API_BASE_URL).
// Fallback sur la prod si la variable n'est pas fournie.
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'https://guepard.gams-pro.com/api'

// Intercepteur pour injecter le token dans TOUTES les requêtes
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('api_token');
    // Ne jamais envoyer un ancien token sur /login : s'il est expiré/révoqué
    // (ex. redémarrage backend), il ferait rejeter la connexion avant même
    // la vérification des identifiants.
    const isLoginCall = String(config.url || '').replace(/^\/+/, '') === 'login';
    if (isLoginCall) {
        // Retire un éventuel header par défaut (axios.defaults.headers.common) déjà fusionné dans config
        delete config.headers.Authorization;
    } else if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // S'assurer que le backend reçoit du JSON et sait qu'il s'agit d'une requête AJAX
    config.headers['Accept'] = 'application/json';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // Évite la page d'avertissement HTML d'ngrok (backend local exposé en dev)
    config.headers['ngrok-skip-browser-warning'] = 'true';

    return config;
});

// Injection initiale si le token existe déjà
const token = localStorage.getItem('api_token')
if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
